// @ts-check
import { Loader } from "@googlemaps/js-api-loader";
import { getAll, get } from "../utilities/querySelector";


class CardToggle extends HTMLElement {
    static observedAttributes = ['toggles-closest'];

    constructor() {
        super();
    }

    connectedCallback() {
        this._setupEls();

        if ( !this.toggler ) console.error( 'The nu-card-toggle component requires a button element as a child.' );

        this._setupListeners();
    }

    disconnectedCallback() {
        this._clearListeners();
    }

    adoptedCallback() {
        this._clearListeners();
        this._setupEls();

        if ( !this.toggler ) console.error( 'The nu-card-toggle component requires a button element as a child.' );

        this._setupListeners();
    }

    attributeChangedCallback( name, oldValue, newValue ) {
        this[name] = newValue;
        switch ( name ) {
            case 'toggles-closest':
                this.onClosestChange( oldValue, newValue );
                break;
        }
    }

    onClosestChange( oldValue, newValue ) {
        this.card = this.closest( newValue );
    }

    _setupEls() {
        this.toggler = get( 'button', this );
        this.card = this.closest( this.getAttribute( 'toggles-closest' ) || 'div' );
    }

    _setupListeners() {
        this.toggler.addEventListener( 'click', this.onClick );

    }

    _clearListeners() {
        this.toggler.removeEventListener( 'click', this.onClick );
    }

    onClick = () => {
        this.card.toggleAttribute( 'data-active' );
    };
}

customElements.define( 'nu-card-toggle', CardToggle );



initMaps();

async function initMaps() {
    const loader = new Loader( {
        apiKey: Nu.maps.api_key,
    } );

    await Promise.all( [
        loader.importLibrary( 'marker' ),
        loader.importLibrary( "maps" )
    ] );

    customElements.define( 'nu-card-map', CardMap );
}


class CardMap extends HTMLElement {
    static observedAttributes = ['latitude', 'longitude', 'map-id'];
    latitude;
    longitude;

    constructor() {
        super();
    }

    connectedCallback() {
        initMap( this, Number( this.latitude ), Number( this.longitude ) );
    }

    disconnectedCallback() {

    }

    adoptedCallback() {

    }

    attributeChangedCallback( name, oldValue, newValue ) {
        this[name] = newValue;
    }
}


function initMap( element, lat, lng ) {
    if ( !lat || !lng ) { console.warn( 'nu-card-map requires valid lat/lng data to work!' ); return; };
    const map = new google.maps.Map( element, {
        center: { lat, lng },
        zoom: 14,
        mapTypeControl: false,
        fullscreenControl: false,
    } );

    const marker = new google.maps.Marker( {
        position: { lat, lng },
        map: map,
        title: `Marker ${element.id}`
    } );
}